import { Injectable } from '@angular/core';
import {
  TREQUEST_AI_ANALYTICS_FIRST_QUESTION,
  TREQUEST_AI_ANALYTICS_FOLLOW_UP_QUESTION,
  TREQUEST_AI_ANALYTICS_GENERATE_INSIGHTS,
  TREQUEST_AI_ANALYTICS_SUBMIT_FEEDBACK,
  TRESPONSE_AI_ANALYTICS_QUESTION,
} from '@monorepo/types';
import { TChatUiModel } from '@monorepo/ui/chat-ui';
import { select, Store } from '@ngrx/store';
import { catchError, lastValueFrom, map, of } from 'rxjs';
import { IAppState } from '..';
import { AiAnalyticsProviderService } from '../../reporting/providers/ai-analytics.provider';
import * as AiAnalyticsActions from './ai-analytics.actions';
import * as AiAnalyticsSelector from './ai-analytics.selectors';

@Injectable({
  providedIn: 'root',
})
export class AiAnalyticsFacade {
  constructor(private store: Store<IAppState>, private aiAnalyticsProvider: AiAnalyticsProviderService) {}

  setChatUiModel(payload: TChatUiModel<TRESPONSE_AI_ANALYTICS_QUESTION>) {
    this.store.dispatch(new AiAnalyticsActions.SetAiAnalyticsChatUiModel(payload));
  }

  getChatUiModel() {
    return this.store.pipe(select(AiAnalyticsSelector.getChatUiModel));
  }

  setLastSeparatorText(text: string | null) {
    this.store.dispatch(new AiAnalyticsActions.SetAiAnalyticsLastSeparatorText(text));
  }

  getLastSeparatorText() {
    return this.store.pipe(select(AiAnalyticsSelector.getLastSeparatorText));
  }

  async askFirstQuestion(payload: TREQUEST_AI_ANALYTICS_FIRST_QUESTION) {
    return lastValueFrom(
      this.aiAnalyticsProvider.aiAnalyticsAskFirstQuestion(payload).pipe(
        map((res) => res),
        catchError(() => of(null)),
      ),
    );
  }

  async askFollowUpQuestion(payload: TREQUEST_AI_ANALYTICS_FOLLOW_UP_QUESTION) {
    return lastValueFrom(
      this.aiAnalyticsProvider.aiAnalyticsAskFollowUpQuestion(payload).pipe(
        map((res) => res),
        catchError(() => of(null)),
      ),
    );
  }

  generateInsights(payload: TREQUEST_AI_ANALYTICS_GENERATE_INSIGHTS) {
    return lastValueFrom(
      this.aiAnalyticsProvider.aiAnalyticsGenerateInsights(payload).pipe(
        map((res) => res),
        catchError(() => of(null)),
      ),
    );
  }

  async submitFeedback(payload: TREQUEST_AI_ANALYTICS_SUBMIT_FEEDBACK) {
    return lastValueFrom(
      this.aiAnalyticsProvider.aiAnalyticsSubmitFeedback(payload).pipe(
        map(() => true),
        catchError(() => of(false)),
      ),
    );
  }
}
